export enum MessageContentType {
  Text = "text",
  Toolconfirmationprompt = "toolConfirmationPrompt",
  Uicomponent = "uiComponent",
  Uicomponentresult = "uiComponentResult",
}
